module.exports = __webpack_public_path__ + "img/menu-transaction-yellow.cc01394a.svg";